// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb.jsonpath{margin-bottom:auto;padding:.3em}", ""]);
// Exports
module.exports = exports;
